<template>
  <div class="brow-layout" @click="closeVideo">
    <div class="con" @click.stop>
        <video :src="`${$cdn}course/videos/${url}.mp4`" autoplay controls loop></video>
    </div>
  </div>
</template>

<script>
export default {
  props: ['url'],
  data () {
    return {

    }
  },
  methods: {
    closeVideo () {
      this.$bus.$emit('toggleVideo', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.brow-layout{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0,0,0,0.4);
  z-index: 9999;
  .con{
    position: fixed;
    width: 960px;
    height: auto;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
    video{
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/browseVideo/index.vue